module.exports = __webpack_public_path__ + "static/media/development.8a79b0db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work/development.png
// module id = 398
// module chunks = 1